import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const CheckoutContainer = styled.div({
	margin: "16px",
	backgroundColor: "#f7f7f7",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});

export const CheckoutHeaderItem = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	color: theme.project.colors.fontColors.main,
	height: "56px",
	h4: {
		fontWeight: 200
	}
}));

export const SectionTitle = styled.p(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2
}));

export const SectionText = styled.p(({ theme }) => ({
	...theme.project.typography.body.body2
}));

export const DetailsBoxTitle = styled.p(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1
}));

export const DetailsBox = styled(Card)({
	padding: "16px",
	borderRadius: "unset",
	p: {
		margin: 0
	},
	display: "flex",
	flexDirection: "column",
	gap: "16px"
});
